module.exports = __webpack_public_path__ + "static/media/group-12.8bcf86b9.jpg";